import translate from "../../../common/Dictionary";
import BootstrapModal from '../../../common/BootstrapModal';
import warningFill from "../../../../img/icon_fill_warning.svg";

const ServiceChangeWarningModal = ({ shown, userData, onAccept, onReject }) => {
    return (
        <BootstrapModal
            shown={shown}
            size="modal-lg"
            onClose={onReject}
            body={
                <>
                    <div className="d-flex gap-3 axa-warning-modal-padding">
                        <div align="left">
                            <img src={warningFill} alt="check-provider" />
                        </div>
                        <div className="flex-fill" align="left">
                            <div className="axa-success-box-header pt-1">
                                {translate("newProjectServiceAreYouSureTitle", userData.language)}
                            </div>
                            <div className="axa-success-box-text py-2">
                                {translate("newProjectServiceAreYouSureText", userData.language)}
                            </div>
                        </div>
                    </div>
                    <div className="d-flex flex-md-row-reverse flex-column mt-3 axa-warning-modal-padding">
                        <button className="btn btn-primary" onClick={onReject}>
                            {translate("newProjectServiceAreYouSureCancelButton", userData.language)}
                        </button>
                        <button className="btn" onClick={onAccept}>
                            {translate("newProjectServiceAreYouSureApproveButton", userData.language)}
                        </button>
                    </div>
                </>
            }
        />
    );
};

export default ServiceChangeWarningModal;
